import { getFeatureToggles } from '@common/permissions/selectors';
import TabbableContent from '@components/TabbableContent';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { PermissionsStatePart } from '../../setup/types';
import CalculationParamsSettings from './calculationParamsSettings/CalculationParams';
import UnitFormat from './metricSettings/UnitFormat';

const TAB_KEY = 'admin.activeTab';

const AdministrationEntry: React.FC<{
    imperialFt: boolean;
}> = ({ imperialFt }) => {
    const [activeTab, setActiveTab] = useState<number>(() => {
        const saved = sessionStorage.getItem(TAB_KEY);
        return saved ? Number(saved) : 0;
    });

    const tabs = [
        {
            title: (
                <span className="text-size-14">
                    <FormattedMessage id="administration.rating" />
                </span>
            ),
            content: <CalculationParamsSettings key="cp" />,
        },
        ...(imperialFt
            ? [
                  {
                      title: (
                          <span className="text-size-14">
                              <FormattedMessage id="administration.metric.format" />
                          </span>
                      ),
                      content: <UnitFormat key="uf" />,
                  },
              ]
            : []),
    ];

    const safeActiveTab = Math.min(activeTab, tabs.length - 1);

    return imperialFt ? (
        <div data-test="AdministrationEntry">
            <div className="display-flex margin-left-5pct margin-right-5pct gap-2 border-bottom-only border-style-solid border-color-dark">
                {tabs.map((elem, index) => {
                    return (
                        <div
                            key={index}
                            data-test={`admin-tab-${index}`}
                            className={`cursor-pointer border-bottom-only border-color-dark padding-y-10 padding-x-15 ${
                                activeTab === index ? 'border-style-solid border-width-3' : ''
                            }`}
                            onClick={() => {
                                sessionStorage.setItem(TAB_KEY, String(index));
                                setActiveTab(index);
                            }}
                        >
                            <span>{elem.title}</span>
                        </div>
                    );
                })}
            </div>
            <div className="margin-left-5pct margin-right-5pct padding-top-20">{tabs[safeActiveTab].content}</div>
        </div>
    ) : (
        <div style={{ margin: '0 auto' }} className="container-fluid fluid-default" data-test="AdministrationEntry">
            <TabbableContent tabs={tabs} />
        </div>
    );
};

const mapStateToProps = (state: PermissionsStatePart) => ({
    imperialFt: getFeatureToggles(state).imperial as boolean,
});

export default connect(mapStateToProps)(AdministrationEntry);
